

import React, { memo } from 'react';
import INITIALS_PLACEHOLDER from '../styles/initialsPlaceholder';







function InitialsPlaceholder({ string, size, fontSize }) {
  const initialsMatches = string.match(/\b(\w)/g) || [];

  if (!initialsMatches.length) {return null;}

  // Only take first 2 letters
  const initials = initialsMatches.slice(0, 2).join('');

  return (
    <div
      className={INITIALS_PLACEHOLDER}
      style={{
        width: size,
        height: size,
        fontSize
      }}>

      <span>{initials.toUpperCase()}</span>
    </div>);

}

export default memo(InitialsPlaceholder);